import { useState } from 'react';

import { useShowcaseGroupQuery } from '~/domains/mmp/queries/useShowcaseGroup';
import ShowcaseGroupFilterList from '~/domains/mmp/ShowcaseGroup/ShowcaseGroupFilterList';
import type { OAISchema } from '~/types/openapi';

import EventShowcaseBody from '../EventShowcaseBody';

const ShowcaseGroupLoaded = ({
  displayType,
  showcaseGroup,
}: {
  displayType: string;
  showcaseGroup: OAISchema['ShowcaseGroupResponse'];
}) => {
  const { showcases } = showcaseGroup;

  const [selectedShowcase, setSelectedShowcase] = useState<
    OAISchema['ShowcaseResponse']
  >(showcaseGroup?.showcases[0]);

  const onClickCode = (selectedCode: string) => {
    const target = showcases.find(({ code }) => code === selectedCode);
    if (target) {
      setSelectedShowcase(target);
    }
  };

  return (
    <div className="relative">
      <div className="-mx-20">
        <ShowcaseGroupFilterList
          selectedShowcaseCode={selectedShowcase.code}
          showcaseGroupName={selectedShowcase.name || ''}
          showcases={showcases || []}
          onClickCode={onClickCode}
        />
      </div>
      <div className="pt-16">
        <EventShowcaseBody
          displayType={displayType}
          showcaseCode={selectedShowcase.code}
        />
      </div>
    </div>
  );
};

interface Props {
  displayType: string;
  code: string;
}

const ShowcaseGroupContent = ({ displayType, code }: Props) => {
  const { data: showcaseGroup } = useShowcaseGroupQuery(code, true);

  return (
    <ShowcaseGroupLoaded
      displayType={displayType}
      showcaseGroup={showcaseGroup as never}
    />
  );
};

export default ShowcaseGroupContent;
